const event={
    duplicateSourceEid:null,
    avenueHubEid:null,
    isOpenLocaleStep:null,
};

export default event;